<template>
  <BaseNoticeItem>
    <template #head>
      <strong>{{ $t('This contract setup is not valid') }}</strong>
    </template>
    <template #body>
      <strong>{{ $t('Please reach out to your client to discuss this matter further.') }}</strong>
      <br />
      <br />
      {{
        $t('The initial setup could be invalid due to a change in your business setup or location.')
      }}
      <br />
    </template>
    <template #action></template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
  hire: {
    type: Object,
    required: true,
  },
  isComplete: {
    type: Boolean,
    required: true,
  },
})

const { $t } = useTranslation()

const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(namedRoutes.frontend.user.profile.edit, {
    redirect_uri: redirectUri,
  })
  return `${path}#business-entity`
})
</script>
